'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiEjectOutline = function TiEjectOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm26.7 14.3v-2.6c0-1.9-1.5-3.4-3.4-3.4h-16.6v16.7c0 1.8 1.5 3.3 3.3 3.3h1.8c1.5 4.8 6.1 8.4 11.3 8.4 6.5 0 11.8-5.1 11.8-11.5 0-5.3-3.5-9.6-8.2-10.9z m-13.4 3.1v5.4c0 0.9-0.7 1.6-1.6 1.6s-1.7-0.7-1.7-1.6v-11.1h11.1c0.9 0 1.7 0.7 1.7 1.6s-0.8 1.7-1.7 1.7h-5.4l8 8c0.6 0.6 0.6 1.7 0 2.4-0.3 0.3-0.7 0.4-1.2 0.4-0.4 0-0.9-0.1-1.2-0.4l-8-8z m10 16c-4.6 0-8.3-3.8-8.3-8.4 0-1.1 0-2.3 0.4-3.3l4.8 4.8c0.6 0.7 1.5 1 2.3 1s1.7-0.3 2.4-1c1.3-1.3 1.3-3.4 0-4.7l-4.3-4.3c0.9-0.3 1.8-0.6 2.7-0.6 4.6 0 8.4 3.6 8.4 8.2 0 4.6-3.8 8.3-8.4 8.3z' })
        )
    );
};

exports.default = TiEjectOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/eject-outline.js
// module id = 1876
// module chunks = 0